import type { JSX } from 'react';

import type { ItemMenuInterface, MenuInterface } from '../Header/Header.types';

interface Props {
  menu: MenuInterface[];
  ItemMenu: (item: ItemMenuInterface, key: number) => JSX.Element;
}

export const HeaderMenu = ({ menu, ItemMenu }: Props) => <div className="header__menu">{menu.map(ItemMenu)}</div>;
